<template>
  <div class="relative">
    <!-- Navbar -->
    <div class="sticky top-0 bg-white shadow">
      <div class="px-6 py-4 mx-auto max-w-7xl">
        <div class="flex items-center leading-tight">
          <img src="@/assets/img/logo-radar.svg" alt="Fleetbeacon Portal" class="flex-none h-8 mr-4">
          <div class="text-sm leading-tight uppercase">
            <div class="font-bold text-gray-900">
              Fleetbeacon
            </div>
            <div class="font-medium text-blue-500">
              Radar
            </div>
          </div>
        </div>
      </div>
    </div>

    <main>
      <!-- Hero -->
      <section class="relative bg-gray-100 bg-grid-gray">
        <div class="absolute top-0 right-0 w-full h-full overflow-hidden lg:w-2/3 opacity-20">
          <div class="relative h-full">
            <div class="absolute inset-0 z-10 h-full bg-gradient-to-r from-gray-100 to-transparent"></div>
            <img src="/images/hero/radar-hero-bg.jpg" alt="" class="absolute right-0 z-0 w-full min-h-full">
          </div>
        </div>
        <div class="relative z-10 flex items-center w-full px-6 pt-16 pb-20 mx-auto text-center max-w-7xl lg:py-24 lg:text-left">
          <div class="max-w-xl mx-auto lg:mx-0">
            <h2 class="text-5xl font-extrabold leading-none tracking-tight text-gray-800 sm:text-5xl sm:leading-none md:text-6xl">
              Make Fleet Operations
              <br>
              <span class="text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-blue-400">
                Effortless
              </span>
            </h2>
            <p class="max-w-md mx-auto mt-3 text-lg text-gray-600 sm:text-2xl md:mt-5 md:max-w-3xl">
              Save time and money, reduce operational overhead, and automate your risk management with a platform that monitors your fleet 24/7.
            </p>
            <div class="mt-10 sm:flex sm:justify-center lg:justify-start">
              <div >
                <router-link :to="{ name: 'Register' }" class="btn btn-blue btn-xl">
                  Start a Free Trial
                </router-link>
              </div>
              <div class="mt-3 sm:mt-0 sm:ml-3">
                <router-link :to="{ hash: '#features' }" class="btn btn-secondary btn-xl">
                  Learn More <span class="ml-2 animate-bounce">&darr;</span>
                </router-link>
              </div>
            </div>
          </div>
          <div class="hidden lg:block lg:w-1/2">
            <div class="max-w-xl ml-16">

            </div>
          </div>
        </div>
      </section>

      <div class="relative pb-32 space-y-24 overflow-hidden" id="features">
        <div aria-hidden="true" class="absolute inset-x-0 top-0 h-48 border-t opacity-50 bg-gradient-to-b from-gray-200"></div>
        
        <!-- Features -->
        <template v-for="(feature, index) in features">
          <div :key="feature.icon" class="relative">
            <div class="lg:mx-auto lg:max-w-7xl lg:px-8 lg:grid lg:grid-cols-2 lg:grid-flow-col-dense lg:gap-24">
              <div class="max-w-xl px-4 mx-auto sm:px-6 lg:py-16 lg:max-w-none lg:mx-0 lg:px-0">
                <div>
                  <div class="inline-flex items-center rounded-full bg-gradient-to-r from-blue-100 to-transparent">
                    <span class="flex items-center justify-center flex-none text-white bg-blue-500 rounded-full w-9 h-9">
                      <fa :icon="['fas', feature.icon]" class="text-lg" />
                    </span>
                    <div class="pl-3 pr-20 font-bold leading-tight tracking-wide text-blue-500 uppercase" v-html="feature.name">
                    </div>
                  </div>
                  <div class="mt-6">
                    <h2 class="text-4xl font-extrabold leading-tight tracking-tight text-gray-900">
                      {{ feature.title }}
                    </h2>
                    <p class="mt-4 text-lg text-gray-500">
                      {{ feature.lead }}
                    </p>
                  </div>
                  <div class="grid gap-4 mt-6">
                    <div v-for="section in feature.sections" :key="section.heading">
                      <div class="font-semibold text-gray-700">
                        <fa :icon="['far', 'check']" class="mr-1 text-blue-500" /> {{ section.heading }}
                      </div>
                      <div class="ml-6 text-sm text-gray-500">
                        {{ section.body }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="mt-12 sm:mt-16 lg:mt-0">
                <div class="pl-4 -mr-48 sm:pl-6 md:-mr-16 lg:px-0 lg:m-0 lg:relative lg:h-full">
                  <img class="object-cover shadow-xl bg-gradient-to-bl from-gray-300 to-gray-200 rounded-xl ring-1 ring-black ring-opacity-5 lg:absolute lg:left-0 lg:h-full lg:w-auto lg:max-w-none" :src="feature.image" :alt="feature.name">
                </div>
              </div>
            </div>
          </div>
        </template>

        
        <!-- Pricing -->
        <div class="px-6 mx-auto max-w-7xl">
          <pricing-radar />
        </div>
      </div>
    </main>
    
  </div>
</template>

<script>
import { features } from '@/store/products/radar'
import PricingRadar from '@/views/site/pricing/PricingRadar'

export default {
  name: 'ProductRadar',

  metaInfo: {
    title: 'Products » Radar',
  },
  
  components: {
    PricingRadar
  },

  data () {
    return {
      features
    }
  }
}
</script>